import React from 'react';
import { StyledErrorPage } from '@bingads-webui/ad-library-common-components';
import { InstrumentationServiceContext } from '@bingads-webui/ad-library-instrumentation';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.resetError = this.resetError.bind(this);
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(prevProps) {
    // Recover from the error state once the user navigates to a different route,
    // so a single failed page does not leave the whole app stuck on the error UI.
    if (this.state.hasError && prevProps.routeKey !== this.props.routeKey) {
      this.resetError();
    }
  }

  componentDidCatch(error, errorInfo) {
    const logger = this.context;
    if (logger && typeof logger.logError === 'function') {
      logger.logError('Unhandled error caught by ErrorBoundary', {
        message: error && error.message,
        stack: error && error.stack,
        componentStack: errorInfo && errorInfo.componentStack,
      });
    }
  }

  resetError() {
    this.setState({ hasError: false });
  }

  render() {
    if (this.state.hasError) {
      return <StyledErrorPage resetError={this.resetError} />;
    }

    return this.props.children;
  }
}

ErrorBoundary.contextType = InstrumentationServiceContext;

export default ErrorBoundary;
